import { getTemplateNavFooterLevel0Styles } from "./NavFooter-Level0.styles"

const t = document.createElement('template')
t.innerHTML = `
<ul name="footer-links" class="ascend-footer__list">
  <slot></slot>
</ul>
`
const TemplateNavFooterBasic = t

class NavFooterBasicLinks extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavFooterLevel0Styles().content.cloneNode(true))
    shadow.appendChild(TemplateNavFooterBasic.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavFooterBasicLinks connectedCallback')
  }
}

// legacy
//customElements.define('ts-navfooter-basic-links', NavFooterBasicLinks)
// new
if (!customElements.get('ts-navfooter-level0-links')) {
  customElements.define('ts-navfooter-level0-links', NavFooterBasicLinks)
}
export { NavFooterBasicLinks }